<template>
  <div>
    <div class="main-menu" v-if="ShowMenu" style="position:absolute;">
      <FormattingToolbox :Editor="editor">
      </FormattingToolbox>
    </div>
    <div v-if="editor">
      
    </div>
    <div v-if="editor">
      <div style="border:1px solid gray; border-radius:5px; padding:5px;" v-if="!HideEditorToolBar">
        <FormattingToolbox :Editor="editor">
        </FormattingToolbox>
        <ActionsToolbox @Publish="Publish()" @SaveDraft="SaveDraft()" @RevisionHistory="RevisionHistory()"
                        :Editor="editor"></ActionsToolbox>
      </div>
    </div>
    <div style="padding:20px; background-color: white;">
      <editor-content :editor="editor" style="background:white;" />
    </div>
  </div>
</template>

<script>
  import { Editor, EditorContent } from "@tiptap/vue-2";
  import StarterKit from '@tiptap/starter-kit'

  import Table from '@tiptap/extension-table'
  import TableCell from '@tiptap/extension-table-cell'
  import TableHeader from '@tiptap/extension-table-header'
  import TableRow from '@tiptap/extension-table-row'
  import Link from '@tiptap/extension-link'

  import Image from '@tiptap/extension-image'

  import Collaboration from '@tiptap/extension-collaboration'
  import CollaborationCursor from '@tiptap/extension-collaboration-cursor'
  import BubbleMenu from '@tiptap/extension-bubble-menu'
  import Placeholder from '@tiptap/extension-placeholder'


  import FormattingToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/FormattingToolbox.vue';
  import TableToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/TableToolbox.vue';
  import ActionsToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/ActionsToolbox.vue';
  import LinkToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/LinkToolbox.vue';

  import SignalRProvider from '@/views/components/extra-components/editors/providers/SignalRProvider.js';
  import * as Y from 'yjs'

  const CustomTableCell = TableCell.extend({
    addAttributes() {
      return {
        // extend the existing attributes …
        ...this.parent?.(),

        // and add a new one …
        backgroundColor: {
          default: null,
          parseHTML: element => element.getAttribute('data-background-color'),
          renderHTML: attributes => {
            return {
              'data-background-color': attributes.backgroundColor,
              style: `background-color: ${attributes.backgroundColor}`,
            }
          },
        },
      }
    },
  })

  export default {
    components: {
      EditorContent,
      FormattingToolbox,
      Collaboration,
      CollaborationCursor,
      TableToolbox,
      Link,
      ActionsToolbox,
      LinkToolbox
    },

    props: {
      value: {
        type: String,
        default: "",
      },
      editable: {
        type: Boolean,
        default: false
      },
      HideEditorToolBar: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        editor: null,
        ShowMenu: false
      };
    },

    watch: {
      value(newValue) {
        if (newValue !== this.editor.getHTML()) {
          this.editor.commands.setContent(newValue);
        }
      },
      editable(newValue) {
        this.editor.setEditable(newValue);
      }
    },

    methods: {
      handlePaste(e) {
        if (!e.clipboardData || !e.clipboardData.items) return;

        for (const item of e.clipboardData.items) {
          if (item.type.indexOf('image') === 0) {
            e.preventDefault();
            const file = item.getAsFile();
            const reader = new FileReader();

            reader.onload = (event) => {
              this.editor.chain().focus()
                .setImage({ src: event.target.result }).run();
            };

            reader.readAsDataURL(file);
          }
        }
      },
      Publish() {
        this.$emit('Publish');
      },
      SaveDraft() {
        this.$emit('SaveDraft');
      },
      RevisionHistory() {
        this.$emit("RevisionHistory");
      }
    },

    mounted() {

      const ydoc = new Y.Doc();
      // const provider = new SignalRProvider();
      // provider.init(ydoc);

      var instance = this;

      this.editor = new Editor({
        content: this.value,
        extensions: [
          StarterKit,
          Table.configure({
            resizable: true,
          }),
          TableRow,
          TableHeader,
          // Default TableCell
          TableCell,
          // Custom TableCell with backgroundColor attribute
          CustomTableCell,
          Image.configure({
            allowBase64: true,
            inline: true
          }),
          BubbleMenu.configure({
            pluginKey: 'bubbleMenuOne',
            element: document.querySelector('.commands-button'),
            tippyOptions: {
              placement: "left"
            },
            shouldShow: ({ editor, view, state, oldState, from, to }) => {
              // only show the bubble menu for images and links
              return editor.isActive('');
            },
          }),
          //BubbleMenu.configure({
          //  pluginKey: 'bubbleMenuOne',
          //  element: document.querySelector('.table-menu'),
          //  tippyOptions: {
          //    placement:"bottom"
          //  },
          //  shouldShow: ({ editor, view, state, oldState, from, to }) => {
          //    // only show the bubble menu for images and links
          //    return editor.isActive('table');
          //  },
          //}),
          //BubbleMenu.configure({
          //  pluginKey: 'bubbleMenuTwo',
          //  element: document.querySelector('.menu-two'),
          //  tippyOptions: {
          //    placement: "bottom"
          //  },
          //  shouldShow: ({ editor, view, state, oldState, from, to }) => {
          //    return editor.isActive('image')
          //  }
          //}),
          //BubbleMenu.configure({
          //  pluginKey: 'bubbleMenuThree',
          //  element: document.querySelector('.link-menu'),
          //  tippyOptions: {
          //    placement: "bottom"
          //  },
          //  shouldShow: ({ editor, view, state, oldState, from, to }) => {
          //    return editor.isActive('link')
          //  }
          //}),
          Placeholder.configure({
            placeholder: ({ node }) => {
              return 'Type your content here...'
            },
          }),
          Link.configure({
            openOnClick: false,
          }),
          Collaboration.configure({
            document: ydoc,
          }),
        ],
        onUpdate: ({ editor }) => {
          const html = editor.getHTML();
          if (html !== this.value) {
            this.$emit('input', html);
          }
        },
        editorProps: {
          handlePaste: function (view, event, slice) {
            instance.handlePaste(event);
            return false;
          }
        },
      });
    },

    beforeDestroy() {
      if (this.editor) {
        this.editor.destroy();
      }
    },
  };
</script>

<style lang="scss">
  .tcv-componentTiptap {
    background-color: #fff;
  }

  .tcv-componentTiptap .vx-navbar-wrapper {
    background: white !important;
  }

  .tcv-componentTiptap .router-header {
    display: none !important;
  }

  /* Basic editor styles */
  .tiptap {

    ul {
      list-style-type: circle;
      font-size: 40px;
    }


    ol {
      list-style-type: decimal-leading-zero;
      font-size: 22px;
    }

    margin: 1rem 0;

    > * + * {
      margin-top: 0.75em;
    }

    ul,
    ol {
      padding: 0 1rem;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
    }

    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }

    pre {
      background: #0D0D0D;
      color: #FFF;
      font-family: 'JetBrainsMono', monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;

      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }

    img {
      max-width: 100%;
      height: auto;
    }

    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0D0D0D, 0.1);
    }

    hr {
      border: none;
      border-top: 2px solid rgba(#0D0D0D, 0.1);
      margin: 2rem 0;
    }
  }

  /* Table-specific styling */
  .tiptap {
    table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      margin: 0;
      overflow: hidden;

      td,
      th {
        min-width: 1em;
        border: 2px solid #ced4da;
        padding: 3px 5px;
        vertical-align: top;
        box-sizing: border-box;
        position: relative;

        > * {
          margin-bottom: 0;
        }
      }

      th {
        font-weight: bold;
        text-align: left;
        background-color: #f1f3f5;
      }

      .selectedCell:after {
        z-index: 2;
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(200, 200, 255, 0.4);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: -2px;
        width: 4px;
        background-color: #adf;
        pointer-events: none;
      }

      p {
        margin: 0;
      }
    }
  }

  .tableWrapper {
    overflow-x: auto;
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

  .tiptap p {
    font-size: 21px;
  }

  .tiptap h1,
  .tiptap h2 {
    font-weight: 100;
  }



  .tiptap p.is-empty::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
    font-size: 21px;
  }

  </style>
